import React, {
  useEffect,
  useRef,
  useCallback
} from 'react';
import {
  useSlateStatic,
  ReactEditor,
} from 'slate-react';
import DOMPurify from 'dompurify';

import { mount, unmount } from 'redom';

import Helpers from '../../helpers';

import BaseElement from '../base';

function EmailQuote(props) {

  const element = props.element;

  const editor = useSlateStatic();

  function renderEmailQuote() {

    const mainAttributes = {
      ...props.attributes,
      className: 'email-quote-element',
      contentEditable: false
    };

    const options = element.options;
    const sanitizedHTML = DOMPurify.sanitize(options?.content);

    return <div {...mainAttributes}>
      <div className="email-quote-header" dangerouslySetInnerHTML={{ __html: options?.header }} />
      <blockquote>
        <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
      </blockquote>
      {props.children}
    </div>;

  }

  function renderMain() {

    return renderEmailQuote();

  }

  return renderMain();

}

export default EmailQuote;